<template>
    <select>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
    </select>
</template>

<script>
    export default {
        props:   [
            'id',
            'value',
            'readonly'
        ],
        beforeMount() {
            const self = this;

            self.$emit('input', Number(self.value));
        },
        mounted: function () {
            const self = this;

            jQuery(this.$el)
                .barrating({
                    theme:         'icofont-stars',
                    initialRating: self.value,
                    readonly:      self.readonly ? self.readonly : false
                })
                .on('change', function () {
                    self.$emit('input', {skill_id: self.id, rate: Number(this.value)});
                    self.$emit('select', {skill_id: self.id, rate: Number(this.value)});
                });
        },
        watch:   {
            value: function (value) {
                // update value
                jQuery(this.$el)
                    .barrating('set', Number(value));

                this.$emit('select', {skill_id: self.id, rate: Number(value)});
            },
        },
        unmounted() {
            jQuery(this.$el)
                .off()
                .barrating('destroy');
        }
    }
</script>